interface IBrokerAffillliate {
  affiliateName: string;
  affiliateId: number;
}

export interface IBroker {
  brokerID: 0;
  companyID: 0;
  affiliateID: 0;
  brokerName: string;
  preferredName: string;
  primaryPhone: string;
  primaryEmail: string;
  companyName: string;
  branchName?: string;
  affiliateName: string;
  externalID: number;
  deleted?: boolean;
  isSMSTextEnabled: boolean;
  fromBrokerQuoteEngine?: boolean;
  brokerProduction: {
    carrierTypeDesc: string;
    appCount: number;
    paidPremium: number;
  }[];
  brokerLogo: string;
  logo: string | ArrayBuffer;
  brokerAffiliates: IBrokerAffillliate[];
}

export interface IBrokerImage {
  brokerID: 0;
  formData: FormData;
  imagePreview: string | ArrayBuffer;
}

export const defaultBroker: Readonly<IBroker> = {
  brokerID: null,
  companyID: null,
  affiliateID: null,
  brokerName: "",
  preferredName: "",
  primaryPhone: "",
  primaryEmail: "",
  companyName: "",
  affiliateName: "",
  externalID: null,
  isSMSTextEnabled: true,
  fromBrokerQuoteEngine: null,
  brokerProduction: [
    {
      carrierTypeDesc: undefined,
      appCount: undefined,
      paidPremium: undefined,
    },
  ],
  brokerLogo: null,
  logo: null,
  brokerAffiliates: [],
};
